var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"sendQuote","title":"Send Quote","ok-only":true,"ok-title":"Close","lazy":true,"size":"lg"}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.$store.getters['config/link']('sendQuote'),"width":"100","frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e5ece","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MSendQuote.vue
// module id = null
// module chunks = 